export const RANGE = 960;
